import { Button, Flex } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { DynamicFilterKey, type DynamicFilters } from '@/types/storefront';

import { SelectedOptionChip } from './SelectedOptionChip';

type SelectedOptionChipListProps = {
  dynamicFiltersSelectedValues?: DynamicFilters;
  onOptionRemove: (filterOption: string, filterKey: DynamicFilterKey) => void;
  onClearAllFilters: () => void;
};

export const SelectedOptionChipList = ({
  dynamicFiltersSelectedValues,
  onOptionRemove,
  onClearAllFilters,
}: SelectedOptionChipListProps) => {
  const { t } = useTranslation('common');
  const hasFilters = Object.keys(dynamicFiltersSelectedValues ?? {}).length > 0;

  return (
    <>
      {dynamicFiltersSelectedValues && (
        <Flex gap="2rem" wrap alignItems="center">
          {(
            Object.keys(dynamicFiltersSelectedValues) as DynamicFilterKey[]
          ).map(filterKey => {
            const selectedOptions = dynamicFiltersSelectedValues[filterKey];

            return selectedOptions?.map(selectedOption => (
              <SelectedOptionChip
                key={selectedOption}
                filterOption={selectedOption}
                filterKey={filterKey}
                onRemove={onOptionRemove}
              />
            ));
          })}
          {hasFilters && (
            <Button
              id="clear-all-button"
              variant="text"
              onClick={() => onClearAllFilters()}>
              {t('storefront.filters.clearAll')}
            </Button>
          )}
        </Flex>
      )}
    </>
  );
};
